import { apiConstants, ACL } from '../config';
let code = apiConstants.code;
let codeAPI = apiConstants.codeAPI;

export const getDefaultState = () => {
    return {
        error: null,
        loading: false,
        data: {
            code: code,
            codeAPI: codeAPI,
            module: {},
            panels: {
                home: {
                    panel: {
                        showMessageBroadcast: true,
                        showAddFeatureAnonynous: false,
                    },
                    acl: {
                        view: 'MB_00582',
                        add: 'MB_00335',
                        showDirectDetailModal: 'MB_00640',
                        stateTransformTo: 'MB_00334',
                    },
                    url: {
                        getMapFeatures: `${codeAPI}/front/map/features`,
                    },
                },
                headernav: {
                    tools: [
                        {component: 'dashboard', title: 'dashboard.title'},
                        {component: 'accountable', title: 'accountable.title'},
                        {component: 'activity', title: 'activity.title'},
                        {component: 'overdue', title: 'overdue.title'},
                    ]
                },
            },
            tools: {
                broadcasting: {
                    active: true,
                },
                attribution: {
                    active: false,
                },
                scaleline: {
                    active: false,
                },
                scalebox: {
                    active: false,
                },
                mouseposition: {
                    active: false,
                },
                layerswitcher: {
                    acl: {
                        view: 'MB_00611',
                    },
                },
                streetview: {
                    acl: {
                        view: 'MB_00574',
                    },
                },
                annotations: {
                    active: false,
                    acl: {
                        view: 'MB_00641',
                    },
                },
                measure: {
                    active: false,
                    acl: {
                        view: 'MB_00642',
                    },
                },
                backoffice: {
                    active: true,
                    title: 'backoffice.titles',
                    label: 'backoffice.label',
                    panel: {
                        show: false,
                    },
                    acl: {
                        view: 'MB_00575', // Nâo deveria ser o MB_00006??
                    },
                    url: {
                        view: `{moduleCode}gestao.home`
                    }
                },
                catalog: {
                    active: false,
                    acl: {
                        view: 'MB_00638',
                    },
                },
                identify: {
                    active: false,
                    acl: {
                        view: 'MB_00639',
                    },
                },
                layers: {
                    active: true,
                    title: 'layers.titles',
                    label: 'layers.label',
                    panel: {
                        show: false,
                        loaded: false,
                    },
                    acl: {
                        view: 'MB_00331',
                    },
                    url: {
                        getLayers: `${codeAPI}/front/map/layers`,
                    },
                    selected: null,
                },
                regulations: {
                    active: true,
                    title: 'regulations.titles',
                    label: 'regulations.label',
                    panel: {
                        show: false,
                        loaded: false,
                    },
                    acl: {
                        view: 'MB_00661',
                    },
                    url: {
                        getData: `${codeAPI}/front/regulations`,
                    },
                },
                dashboard: {
                    active: true,
                    panel: {
                        show: false,
                        loaded: false,
                    },
                    acl: {
                        view: 'MB_00573',
                    },
                },
                print_visible_emissions: {
                    active: false,
                    title: 'print_visible_emissions.titles',
                    label: 'print_visible_emissions.label',
                    panel: {
                        show: false,
                        loaded: false,
                    },
                    acl: {
                        view: 'MB_00643',
                    },
                    url: {
                        capabilitiesPrint: `${codeAPI}/front/print/visible/capabilities`,
                        createPrint: `${codeAPI}/front/print/visible`,
                        getStatusPrint: `${codeAPI}/front/print/visible/job/:id`,
                    }
                },
                filtertype: {
                    active: true,
                    panel: {
                        show: true,
                        collapsed: true,
                        height: 0,
                    },
                    acl: {
                        view: 'MB_00610',
                    },
                    url: {

                    },
                },
                filterstatus: {
                    active: true,
                    panel: {
                        show: false,
                    },
                    acl: {
                        view: 'MB_00609',
                    },
                    url: {

                    },
                },
                activity: {
                    active: true,
                    title: "activity.title",
                    panel: {
                        show: false,
                        loaded: false,
                        reload: false,
                        titleTemplate: "activity.tooltip",
                        txtNoRecords: "activity.no_records",
                        summary: [],
                        toggles: [
                            { id: 1, key: 'started', name: "activity.toggles.submitted.title", },
                            { id: 2, key: 'finished', name: "activity.toggles.completed.title", },
                        ],
                        reloadBtn: true,
                    },
                    acl: {
                        view: ACL.ACTIVITY.VIEW,
                    },
                    url: {
                        getData: `${codeAPI}/occurrences/data/activity`
                    }
                },
                overdue: {
                    active: true,
                    title: "overdue.title",
                    panel: {
                        show: false,
                        loaded: false,
                        reload: false,
                        titleTemplate: "overdue.tooltip",
                        txtLoadMoreRecords: "overdue.load_more_records",
                        txtNoRecords: "overdue.no_records",
                        summary: [],
                        reloadBtn: true,
                    },
                    acl: {
                        view: 'MB_00632',
                    },
                    url: {
                        getData: `${codeAPI}/occurrences/data/overdue`,
                    },
                },
                search: {
                    active: true,
                    title: "search.title",
                    label: "search.label",
                    panel: {
                        show: false,
                        loaded: false,
                        reload: false,
                        export: {
                            allowExport: true,
                            formats: [
                                // {
                                //     format: "csv",
                                //     title: "occurrence.export.data.csv.title",
                                //     name: "occurrence.export.data.csv.name",
                                //     icon: "fas fa-file-csv",
                                //     status: 1
                                // },
                                {
                                    format: "xls",
                                    title: "occurrence.export.data.xls.title",
                                    name: "occurrence.export.data.xls.name",
                                    icon: "fas fa-file-excel",
                                    status: 1
                                },
                                // {
                                //     format: "kml",
                                //     title: "occurrence.export.data.kml.title",
                                //     name: "occurrence.export.data.kml.name",
                                //     icon: "fas fa-file-code",
                                //     geographic: 1,
                                //     status: 1
                                // },
                                // {
                                //     format: "gml",
                                //     title: "occurrence.export.data.gml.title",
                                //     name: "occurrence.export.data.gml.name",
                                //     icon: "fas fa-file-archive",
                                //     geographic: 1,
                                //     status: 1
                                // },
                                // {
                                //     format: "geojson",
                                //     title: "occurrence.export.data.geojson.title",
                                //     name: "occurrence.export.data.geojson.name",
                                //     icon: "fas fa-file-code",
                                //     geographic: 1,
                                //     status: 1
                                // },
                                // {
                                //     format: "shp",
                                //     title: "occurrence.export.data.shp.title",
                                //     name: "occurrence.export.data.shp.name",
                                //     icon: "fas fa-file-archive",
                                //     geographic: 1,
                                //     status: 1
                                // },
                                // {
                                //     format: "gpkg",
                                //     title: "occurrence.export.data.gpkg.title",
                                //     name: "occurrence.export.data.gpkg.name",
                                //     icon: "fas fa-database",
                                //     geographic: 1,
                                //     status: 1
                                // },
                                // {
                                //     format: "pdf",
                                //     title: "occurrence.export.data.pdf.title",
                                //     name: "occurrence.export.data.pdf.name",
                                //     icon: "fas fa-file-pdf",
                                //     status: 0
                                // }
                            ]
                        },
                        upload: {
                            mimeTypes: [
                                // "application/msword",
                                // "application/vnd.ms-excel",
                                // "application/vnd.ms-powerpoint",
                                // "application/pdf",
                                // "text/plain",
                                // "image/x-png",
                                // "image/bmp",
                                // "image/jpeg",
                                // "image/jpg",
                                // "image/gif",
                                // "image/svg+xml"

                                // CMO
                                "image/x-png",
                                "image/bmp",
                                "image/jpeg",
                                "image/jpg",
                                "image/gif",
                                "image/svg+xml"
                            ],
                            new: {
                                pathProperty: "url",
                                filenameProperty: "filename",
                            }
                        },
                    },
                    acl: {
                        view: 'MB_00613',
                        viewPrivate: 'MB_00633',
                        viewAll: 'MB_00618',
                        viewDetails: 'MB_00583',
                        export: 'MB_00631',
                    },
                    url: {
                        searchAll: `${codeAPI}/occurrences/search`,
                        lists: `${codeAPI}/occurrences/search/lists`,
                        getSubTypes: `${codeAPI}/occurrences/search/subtypes/:type`,
                        searchUser: `${codeAPI}/occurrences/search/user`,
                        export: `${codeAPI}/occurrences/search/export/:type`,
                        job: `${codeAPI}/occurrences/search/export/job/:id`,
                    },
                },
                report: {
                    active: true,
                    title: "report.title",
                    panel: {
                        show: false,
                        loaded: false,
                        reports: {
                            globalstatus: {
                                title: 'reports.global_status.title',
                                allowExportData: true,
                                formatExportData: 'xls',
                                url: {
                                    data: `${codeAPI}/reports/occurrences/totalizer-status`,
                                    export: `${codeAPI}/reports/occurrences/totalizer-status/export`,
                                    job: `${codeAPI}/reports/occurrences/export/job/:id`,
                                }
                            },
                            monthlySummary: {
                                title: 'reports.monthly_summary.title',
                                allowExportData: true,
                                formatExportData: 'xls',
                                url: {
                                    data: `${codeAPI}/reports/occurrences/montly-resume`,
                                    export: `${codeAPI}/reports/occurrences/montly-resume/export`,
                                    job: `${codeAPI}/reports/occurrences/export/job/:id`,
                                }
                            },
                            performerSummary: {
                                title: 'reports.performer_summary.title',
                                allowExportData: true,
                                formatExportData: 'xls',
                                url: {
                                    data: `${codeAPI}/reports/occurrences/occurrences-performer`,
                                    export: `${codeAPI}/reports/occurrences/occurrences-performer/export`,
                                    job: `${codeAPI}/reports/occurrences/export/job/:id`,
                                }
                            },
                            occurrencesSummary: {
                                title: 'reports.occurrences_summary.title',
                                allowExportData: true,
                                formatExportData: 'xls',
                                url: {
                                    data: `${codeAPI}/reports/occurrences/occurrences-summary`,
                                    export: `${codeAPI}/reports/occurrences/occurrences-summary/export`,
                                    job: `${codeAPI}/reports/occurrences/export/job/:id`,
                                }
                            },
                            statusChart: {
                                title: 'reports.status_chart.title',
                                allowExportData: true,
                                formatExportData: 'xls',
                                url: {
                                    data: `${codeAPI}/reports/occurrences/chart-status`,
                                    export: `${codeAPI}/reports/occurrences/chart-status/export`,
                                    job: `${codeAPI}/reports/occurrences/export/job/:id`,
                                }
                            },
                            subtypeChart: {
                                title: 'reports.subtype_chart.title',
                                allowExportData: true,
                                formatExportData: 'xls',
                                url: {
                                    data: `${codeAPI}/reports/occurrences/chart-subtypes`,
                                    export: `${codeAPI}/reports/occurrences/chart-subtypes/export`,
                                    job: `${codeAPI}/reports/occurrences/export/job/:id`,
                                }
                            },
                        },
                    },
                    acl: {
                        view: 'MB_00332',
                        export: 'MB_00332',
                    },
                    url: {
                        lists: `${codeAPI}/reports/occurrences/lists`,
                    },
                },
                navsearch: {
                    active: true,
                    panel: {
                        show: true,
                        showDefault: true,
                        categories: [{
                            'id': 'addr',
                            'name': 'navsearch.address.title',
                            'url': '../gateway/address/search',
                            'listGroup': 'adminName1',
                            'labelTemplate': 'navsearch.address.labelTemplate',
                            'subLabelTemplate': null,
                            'placeholder': 'navsearch.address.placeholder'
                        },
                        {
                            'id': 'mb-oco',
                            'name': 'navsearch.occurrence.title',
                            'url': `${codeAPI}/occurrences/search/code`,
                            'labelTemplate': '${code}',
                            'placeholder': 'navsearch.occurrence.placeholder',
                            'showDetail': true,
                            'acl': 'MB_00637',
                        }],
                        search: {
                            category: null,
                            item: null,
                        },
                    },
                },
                viewfeature: {
                    active: false,
                    title: 'occurrence.show_title',
                    panel: {
                        show: false,
                        loaded: false,
                        enableEdocLink: false,
                        closeAfterCloseEdit: true,
                        upload: {
                            mimeTypes: [
                                // "application/msword",
                                // "application/vnd.ms-excel",
                                // "application/vnd.ms-powerpoint",
                                // "application/pdf",
                                // "text/plain",
                                // "image/x-png",
                                // "image/bmp",
                                // "image/jpeg",
                                // "image/jpg",
                                // "image/gif",
                                // "image/svg+xml"

                                // CMO
                                "image/x-png",
                                "image/bmp",
                                "image/jpeg",
                                "image/jpg",
                                "image/gif",
                                "image/svg+xml"
                            ],
                            new: {
                                pathProperty: "url",
                                filenameProperty: "filename",
                            }
                        }
                    },
                    acl: {
                        view: 'MB_00583',
                        detail: 'MB_00583',
                        edit: 'MB_00570',
                        delete: 'MB_00340',
                        notify: 'MB_00357',
                        viewAsAnonymous: 'MB_00635',

                        viewPriority: 'MB_00601',
                        viewUnity: 'MB_00614',
                        viewVisibility: 'MB_00612',
                        viewInternalData: 'MB_00451',
                        viewOriginalDescription: 'MB_00607',
                        viewDescription: 'MB_00608',
                        viewChannel: 'MB_00600',
                        viewHistory: 'MB_00341',
                        viewType: 'MB_00603',
                        viewSubType: 'MB_00604',
                        viewUserInfo: 'MB_00352',
                        viewEdocLink: 'MB_00622',
                    },
                    url: {
                        show: `${codeAPI}/occurrences/show/:code`,
                        showAnonymous: `${codeAPI}/occurrences/front/:code`,
                        follow: `${codeAPI}/occurrences/follow/:id`,
                    },
                },
                editfeature: {
                    active: false,
                    title: 'occurrence.title',
                    panel: {
                        show: false,
                        loaded: false,
                        enableEdocLink: false,
                        showUserInitially: false,
                        closeAfterSave: true,
                        closeAfterNotification: true,
                        forceApplySameUnityOnChange: true, // CMO = true
                        upload: {
                            imageMain: false,
                            imageSize: 'small',

                            direction: "horizontal",
                            maxFiles: 5,
                            mimeTypes: [
                                "image/x-png",
                                "image/bmp",
                                "image/jpeg",
                                "image/jpg",
                                "image/gif",
                                "image/svg+xml"
                            ],
                            new: {
                                pathProperty: "url",
                                filenameProperty: "filename",
                            }
                        }
                    },
                    acl: {
                        view: 'MB_00583',
                        edit: 'MB_00570',
                        delete: 'MB_00340',
                        notify: 'MB_00357',

                        viewHistory: 'MB_00341',
                        viewPriority: 'MB_00601',
                        // enableVisibility: 'MB_00354',
                        updateVisibility: 'MB_00358',
                        viewVisibility: 'MB_00612',
                        updatePriority: 'MB_00343',
                        updateChannel: 'MB_00342',
                        updateState: 'MB_00344',
                        updateType: 'MB_00345',
                        updateSubType: 'MB_00346',
                        updateUnity: 'MB_00351',
                        updateAssignedTo: 'MB_00375',
                        updateAddress: 'MB_00347',
                        updateReferencePoint: 'MB_00348',
                        updateOriginalDescription: 'MB_00571',
                        viewOriginalDescription: 'MB_00607',
                        updateDescription: 'MB_00349',
                        viewDescription: 'MB_00608',
                        updatePhotos: 'MB_00350',
                        updateEdocLink: 'MB_00356',
                        viewEdocLink: 'MB_00622',
                        viewUserInfo: 'MB_00352',
                        updateAll: 'MB_00339',
                    },
                    url: {
                        show: `${codeAPI}/occurrences/data/:code`,
                        update: `${codeAPI}/occurrences/:id`,
                        delete: `${codeAPI}/occurrences/:id`,
                        lists: `${codeAPI}/occurrences/update/lists`,
                        getSubTypes: `${codeAPI}/occurrences/update/subtypes/:type`,
                        getUnitsBySubtype: `${codeAPI}/occurrences/update/unities/subtypes/:subtype`,
                        getNotificationTemplates: `${codeAPI}/occurrences/notifications/manual/form/1`,
                        getSendNotification: `${codeAPI}/occurrences/notifications/manual/send/:id`,
                    },
                },
                addfeature: {
                    active: true,
                    title: 'occurrence.add_title',
                    panel: {
                        show: false,
                        loaded: false,
                        infoAddFeature: 'occurrence.form.msg.add.help',
                        infoNoPermissionAddFeature: 'occurrence.form.msg.add.not_allowed',
                        infoOutsideAddFeature: 'occurrence.form.msg.add.out_boundary',
                        infoAtiveFilterFeature: 'occurrence.form.msg.add.active_filter',
                        featureable: {
                            status: 0,
                        },
                        upload: {
                            imageMain: true,
                            imageSize: 'large',

                            direction: "horizontal", // 'vertical'
                            maxFiles: 5,
                            mimeTypes: [
                                "image/x-png",
                                "image/bmp",
                                "image/jpeg",
                                "image/jpg",
                                "image/gif",
                                "image/svg+xml"
                            ],
                            new: {
                                pathProperty: "url",
                                filenameProperty: "filename",
                            }
                        },
                        user_consent: {
                            active: false, // CMO - false
                            required: false, // CMO - false
                            text: null
                        },
                        geometry: {
                            geometry_types: ['POINT'],
                            startDefaultControl: true,
                            minfeatures: 1,
                            maxfeatures: 1,
                            draw: {
                                status: 1,
                            },
                            upload: {
                                status: 0,
                            }
                        }
                    },
                    acl: {
                        view: 'MB_00335',
                        allowChannel: 'MB_00353',
                        allowPriority: 'MB_00659',
                        allowSubType: 'MB_00376',
                        allowVisibility: 'MB_00354',
                        allowPhotos: 'MB_00337',
                        allowReportFrom: 'MB_00336',
                        allowReportFromUpdateUser: 'MB_00615',
                        allowReportFromNewUser: 'MB_00338',
                        // [TODO]
                        allowUploadGeometry: null,
                    },
                    url: {
                        create: `${codeAPI}/occurrences`,
                        lists: `${codeAPI}/occurrences/store/lists`,
                        featureable: `${codeAPI}/occurrences/store/featureable/:x/:y/:crs/:resolution`,
                        searchUser: `${codeAPI}/occurrences/store/search/user`,
                        createUser: `${codeAPI}/occurrences/store/user`,
                        updateUser: `${codeAPI}/occurrences/store/user/:id`,
                        formats: `${codeAPI}/front/uploadgeofile/formats`,
                        togeojson: `${codeAPI}/front/uploadgeofile/togeojson`,
                    },
                },
                notifyfeature: {
                    active: true,
                    title: 'occurrence.notify_title',
                    panel: {
                        show: false,
                        loaded: false,
                    },
                    acl: {
                        view: 'MB_00357',
                    },
                    url: {
                        getNotificationTemplates: `${codeAPI}/occurrences/notifications/manual/form/1`,
                        getSendNotification: `${codeAPI}/occurrences/notifications/manual/send`,
                    },
                },
                accountable: {
                    active: true,
                    title: "accountable.title",
                    panel: {
                        show: false,
                        loaded: false,
                        reload: false,
                        data: [],
                        toggles: [
                            {id: 1, key: 'mine', name: "accountable.toggles.mine.title", expanded: false},
                            {id: 2, key: 'assigned_me', name: "accountable.toggles.assigned_me.title", expanded: false},
                            {id: 3, key: 'my_unities', name: "accountable.toggles.my_unities.title", expanded: false},
                        ],
                        reloadBtn: true,
                    },
                    acl: {
                        view: ACL.ACCOUNTABLE.VIEW,
                    },
                    url: {
                        getData: `${codeAPI}/occurrences/data/accountable`,
                    },
                },
                features: {
                    active: true,
                    tooltip: {
                        active: true,
                        template: '<p class="title">:code</p>',
                    },
                    acl: {
                        view: 'MB_00636',
                    },
                },
            },
            states: {
            },
            filters: {
            },
            map: {
                loading: false,
                reload: false,
                action: null,
                user_feature: null,
                filters: {
                    types: [],
                    status: [],
                },
                config: {
                    layers: {
                        features: {
                            scale: .5,
                            scaleSelected: 1,
                            zoom: true,
                            duration: 2500,
                        },
                        cluster: {
                            distance: 100,
                        },
                    },
                    style: {
                        features: {
                            image: {
                                src: require(`@modules/meubairro/images/marker-new.png`),
                                anchor: [.5, 1],
                                scale: .4
                            },
                            stroke: {
                                color: [0, 255, 255, 1],
                                width: 3,
                                opacity: 1,
                            },
                            fill: {
                                color: [0, 153, 255, .4],
                                opacity: .4,
                            },
                            highlight: {
                                image: {
                                    src: require(`@modules/meubairro/images/marker-new.png`),
                                    anchor: [.5, 1],
                                    scale: .8
                                },
                                stroke: {
                                    color: [251, 44, 54, 1],
                                    width: 4,
                                    opacity: 1,
                                },
                                fill: {
                                    color: [251, 44, 54, .4],
                                    opacity: .4,
                                },
                            }
                        },
                        defaultStyle: {
                            polygon: {
                                fill: {
                                    color: [255, 255, 255, 0.4],
                                },
                                stroke: {
                                    // color: [0, 144, 184, 1],
                                    color: [0, 153, 255, 1],
                                    width: 2,
                                    lineCap: 'square',
                                    lineJoin: 'round',
                                }
                            },
                            line: {
                                stroke: {
                                    colorBack: [255, 255, 255, 1],
                                    widthBack: 5,
                                    lineCapBack: 'square',
                                    lineJoinBack: 'round',
                                    // color: [0, 144, 184, 1],
                                    color: [0, 153, 255, 1],
                                    width: 3,
                                    lineCap: 'square',
                                    lineJoin: 'round',
                                }
                            },
                            image: {
                                src: require(`@modules/meubairro/images/marker-new.png`),
                                anchor: [.5, 1],
                                scale: .4
                            }
                        },
                        editingStyle: {
                            polygon: {
                                fill: {
                                    color: [255, 255, 255, 0.5],
                                },
                                stroke: {
                                    // color: [0, 153, 255, 1],
                                    color: [255, 49, 49, 1],
                                    width: 3,
                                    lineCap: 'square',
                                    lineJoin: 'round',
                                }
                            },
                            line: {
                                stroke: {
                                    colorBack: [255, 255, 255, 1],
                                    widthBack: 5,
                                    lineCapBack: 'square',
                                    lineJoinBack: 'round',
                                    // color: [0, 153, 255, 1],
                                    color: [255, 49, 49, 1],
                                    width: 3,
                                    lineCap: 'square',
                                    lineJoin: 'round',
                                }
                            },
                            image: {
                                radius: 7,
                                fill: {
                                    // color: [0, 153, 255, 1],
                                    color: [255, 49, 49, 1],
                                },
                                stroke: {
                                    color: [255, 255, 255, 1],
                                    width: 3/2,
                                    lineCap: 'square',
                                    lineJoin: 'round',
                                }
                            }
                        }
                    },
                    interactions: {
                        spiderfier: true,
                    },
                }
            },
        },
    };
};

const state = getDefaultState();

export default state;